module.exports = __webpack_public_path__ + "img/mem_coupon_font5_m.3a7dcee1.jpg";